var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaistback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.4 289.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    strokeWidth: ".25px",
    stroke: "#1e1e1c",
    x: 2.83,
    y: 0.13,
    width: 141.73,
    height: 289.13
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    y1: 114.28,
    x2: 0.8,
    y2: 114.28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    strokeDasharray: "0 0 1.6 1.6",
    x1: 2.4,
    y1: 114.28,
    x2: 145.8,
    y2: 114.28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    x1: 146.6,
    y1: 114.28,
    x2: 147.4,
    y2: 114.28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    y1: 97.27,
    x2: 0.8,
    y2: 97.27
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    strokeDasharray: "0 0 1.6 1.6",
    x1: 2.4,
    y1: 97.27,
    x2: 145.8,
    y2: 97.27
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    x1: 146.6,
    y1: 97.27,
    x2: 147.4,
    y2: 97.27
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M93.51,268.09l1.84-1.78.02.9h1.59s1.59-.02,1.59-.02l.28-.1c.15-.05.35-.15.45-.22.58-.4.71-1.14.36-1.91-.05-.11-.58-1.05-1.18-2.08-.6-1.03-1.07-1.89-1.06-1.9.07-.06,1.41-.82,1.42-.8,0,.01.49.85,1.08,1.87,1.2,2.07,1.3,2.26,1.46,2.74.61,1.84-.12,3.35-1.89,3.86-.54.15-.6.16-2.36.18l-1.7.02-.03,1.03-1.85-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M87.38,268.78c-1.16-.2-2-.76-2.39-1.57-.17-.35-.22-.59-.24-1.06-.02-.49.03-.82.21-1.35.15-.45.33-.79,1.03-2.01.32-.55.58-1.01.58-1.01l-.77-.48c.11-.03,2.45-.7,2.45-.7.04.08.62,2.46.61,2.47l-.88-.4c-.1.14-1.25,2.15-1.33,2.33-.13.29-.19.59-.17.88.04.61.36,1.01,1.01,1.23l.26.09h2.35s2.35.02,2.35.02v1.63h-2.37c-2.12,0-2.41-.01-2.71-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M88.22,259s2-3.58,2.28-3.97c.3-.43.75-.9,1.12-1.15.23-.15.67-.35.95-.43.72-.18,1.55,0,2.22.5.33.24.82.77,1.07,1.15.12.18.49.81.83,1.39.33.59.61,1.07.62,1.08l.8-.42s-.6,2.45-.62,2.47c-.01.01-2.42-.67-2.44-.7l.82-.53s-1.26-2.22-1.42-2.44c-.39-.56-.97-.85-1.48-.75-.41.08-.81.36-1.08.75-.07.11-.6,1-1.18,2-.58,1-1.07,1.82-1.08,1.83-.47-.24-.95-.5-1.39-.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M92.01,261.94c-.09-.11-.22-.16-.39-.16-.23,0-.39.09-.47.26-.05.1-.08.26-.09.48h-.74c.01-.33.07-.6.18-.8.2-.39.57-.58,1.09-.58.41,0,.74.11.98.34.24.23.37.53.37.91,0,.29-.09.55-.26.77-.11.15-.3.31-.56.5l-.3.22c-.19.14-.32.23-.39.3-.07.06-.13.13-.18.21h1.7v.67h-2.67c0-.28.07-.54.18-.77.11-.26.37-.53.77-.82.35-.25.58-.43.68-.54.16-.17.24-.36.24-.56,0-.17-.05-.3-.14-.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M95.07,261.94c-.09-.11-.22-.16-.39-.16-.23,0-.39.09-.47.26-.05.1-.08.26-.09.48h-.74c.01-.33.07-.6.18-.8.2-.39.57-.58,1.09-.58.41,0,.74.11.98.34.24.23.37.53.37.91,0,.29-.09.55-.26.77-.11.15-.3.31-.56.5l-.3.22c-.19.14-.32.23-.39.3-.07.06-.13.13-.18.21h1.7v.67h-2.67c0-.28.07-.54.18-.77.11-.26.37-.53.77-.82.35-.25.58-.43.68-.54.16-.17.24-.36.24-.56,0-.17-.05-.3-.14-.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M89.57,273.55h-.91v1.54h-.89v-4.27h1.86c.43,0,.77.11,1.03.33.26.22.38.56.38,1.02,0,.51-.13.86-.38,1.07-.26.21-.62.31-1.09.31M89.98,272.66c.12-.1.17-.26.17-.49s-.06-.38-.17-.47c-.12-.1-.28-.14-.49-.14h-.83v1.26h.83c.21,0,.38-.05.49-.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M93.78,274.21h-1.58l-.3.88h-.93l1.52-4.27h1.01l1.51,4.27h-.97l-.27-.88ZM93.53,273.47l-.53-1.68-.55,1.68h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M97.38,273.55h-.91v1.54h-.89v-4.27h1.86c.43,0,.77.11,1.03.33.26.22.38.56.38,1.02,0,.51-.13.86-.38,1.07-.26.21-.62.31-1.09.31M97.79,272.66c.12-.1.17-.26.17-.49s-.06-.38-.17-.47c-.12-.1-.28-.14-.49-.14h-.83v1.26h.83c.21,0,.38-.05.49-.15"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M67.31,256.47h-30.36v11.37c0,3.87,3.19,7.01,7.12,7.01h30.36v-11.37c0-3.87-3.19-7.01-7.12-7.01M73.72,274.15h-29.65c-3.54,0-6.41-2.83-6.41-6.3v-10.67h29.65c3.54,0,6.41,2.83,6.41,6.31v10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M41.44,253.65h-.24v.99h.25c.19,0,.3-.13.3-.5,0-.32-.1-.49-.31-.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M42.6,252.38h-4.24c-.78,0-1.41.64-1.41,1.41v3.38h7.07v-3.38c0-.78-.64-1.41-1.41-1.41M40.21,253.66h-.96v.81h.76v.57h-.76v1.43h-.66v-3.38h1.62v.56ZM41.77,256.47l-.35-1.34h-.22v1.34h-.67v-3.38h.97c.57,0,.91.31.91,1,0,.49-.16.76-.4.89l.44,1.49h-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M67.31,256.47h-14.41l4.97,8.44-4.87,9.94h21.42v-11.37c0-3.87-3.19-7.01-7.12-7.01M69.69,272.24c0,.29-.24.53-.53.53h-.45c-.22,0-.41-.13-.49-.32-.16.2-.41.32-.69.32h-4.9c-.28,0-.53-.13-.69-.32-.08.19-.27.32-.49.32h-.45c-.29,0-.53-.24-.53-.53v-1.9c0-.29.24-.53.53-.53h.45s.07,0,.11.01c-.21-2.34-.54-5.96-.69-7.59-.02-.17.11-.32.27-.33.17-.02.32.11.33.27.24,2.51.88,9.69.89,9.76.01.12.13.22.27.22h4.9c.14,0,.26-.1.27-.22,0-.07.64-7.25.89-9.76.02-.17.16-.29.33-.27.17.02.29.17.27.33-.16,1.64-.48,5.25-.69,7.59.03,0,.07-.01.11-.01h.45c.29,0,.53.24.53.53v1.9ZM64.69,263.18c-.12-.12-.12-.31,0-.42.12-.12.31-.12.42,0l.94.94c.12.12.12.31,0,.42l-.94.94c-.06.06-.13.09-.21.09s-.15-.03-.21-.09c-.12-.12-.12-.31,0-.42l.43-.43s-.02,0-.02,0c-1.14,0-2.07.93-2.07,2.07s.93,2.07,2.07,2.07,2.07-.93,2.07-2.07c0-.27-.05-.54-.16-.79-.06-.15.01-.33.16-.39.15-.06.33,0,.39.16.13.33.2.67.2,1.02,0,1.47-1.2,2.67-2.67,2.67s-2.67-1.2-2.67-2.67,1.2-2.67,2.67-2.67c0,0,.02,0,.03,0l-.43-.43ZM70.07,260.89c0,.11-.03.22-.08.32-.02.04-.06.08-.09.1-.1.07-.21.1-.33.1h-8.96c-.11,0-.23-.03-.33-.1-.04-.03-.07-.06-.1-.1-.05-.1-.08-.21-.08-.32v-.8c0-.35.27-.63.6-.63h.52l.71-.62c.15-.13.38-.21.62-.21h5.04c.24,0,.47.08.62.21l.71.62h.52c.33,0,.6.28.6.63v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M68.83,260.05c-.07,0-.14-.03-.19-.07l-.8-.7s-.12-.06-.23-.06h-5.04c-.11,0-.2.03-.23.06l-.8.7c-.05.05-.12.07-.2.07h-.64s0,.01,0,.04v.73h8.77v-.73s-.01-.04,0-.04h-.64ZM67.61,260h-5.04c-.14,0-.25-.11-.25-.25s.11-.25.25-.25h5.04c.14,0,.25.11.25.25s-.11.25-.25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M27.62,265.48c-.76,1.12-.11,2.59.67,3.33.71.68,1.29.84,1.36.86l.36-.7,1.05,2.88-2.98.6.4-.73-.4-.23c-1.25-.81-1.52-1.92-1.6-2.27-.15-.6-.37-2.38,1.14-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M27.61,265.53c.54,1.24,2.13,1.48,3.18,1.21.93-.24,1.37-.62,1.45-.69h0s-.4-.7-.4-.7l2.99.66-1.08,2.84-.4-.72-.39.21c-1.36.63-2.44.26-2.78.15-.58-.19-2.21-.96-2.56-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M32.9,262.54c-.21,1.48-1.1,2.19-1.38,2.42-.48.39-2,1.35-3.88.56,1.34.21,2.39-.99,2.74-2.02.31-.92.22-1.5.2-1.59h0s-.79-.04-.79-.04l2.16-2.17,1.81,2.44-.82-.05-.03.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M23.82,261.29c-.68,0-1.24-.55-1.24-1.24s.55-1.24,1.24-1.24,1.24.55,1.24,1.24-.55,1.24-1.24,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M21.9,267.3c.11-.29.26-.27.26-.27,0,0,.14-.03.22.26l1.16,4.06c-.96-.28-1.84-.76-2.59-1.39l.95-2.66ZM25.51,256.47c-4.46,0-8.1,3.63-8.1,8.1s3.63,8.1,8.1,8.1c.24,0,.47-.01.71-.04l.05.81,1.48-1.43-1.66-1.26.06.85c-.21.02-.43.03-.65.03-.34,0-.68-.03-1.01-.07l-.03-.22-.77-6.56c-.11-1.24.6-1.43,1.04-1.25l2.45.99c.28.12.42-.11.42-.11,0,0,.16-.25-.12-.43,0,0-3.35-2.22-4.06-2.35-.97-.18-1.93.61-2.15,1.63l-1.19,5.82c-1.02-1.23-1.64-2.8-1.64-4.52,0-3.9,3.17-7.06,7.07-7.06,2.08,0,3.95.9,5.25,2.34l.73-.74c-1.48-1.62-3.61-2.64-5.97-2.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M51.26,261.22l-7.33-1.56c-.11-.03-.23,0-.32.08-.09.07-.13.19-.13.3v.07c.02.35,0,1.36-.05,1.89-.23,2.79-.99,5.22-2.19,7.03-.14.21-.35.5-.47.65l-.11.13c-.08.1-.1.24-.06.35.04.12.14.21.27.24l7.32,1.57s.05,0,.08,0c.11,0,.22-.05.29-.14l.1-.12c.41-.51.86-1.3,1.22-2.11.8-1.81,1.32-3.99,1.56-6.49.03-.33.09-1.15.1-1.41v-.12c.01-.18-.11-.34-.29-.38M50.79,261.88c-.02.35-.07.92-.09,1.18-.23,2.42-.74,4.53-1.5,6.26-.32.72-.72,1.42-1.07,1.88l-6.53-1.4c.1-.13.19-.26.26-.37,1.27-1.91,2.07-4.46,2.31-7.37.03-.41.06-1.1.06-1.59l6.56,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M47.6,261.83c-.08-.09-.2-.14-.32-.14h0c-.27,0-.51.25-.52.56-.01.16.04.32.14.43.08.09.2.14.32.14h0c.27,0,.5-.25.52-.56.01-.17-.04-.32-.14-.43M47.28,261.85v.04c.07,0,.13.02.17.08.06.07.1.17.09.28-.01.2-.16.37-.33.37h0c-.06,0-.12-.02-.17-.07-.06-.07-.09-.17-.09-.28.01-.21.16-.37.33-.37v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M48.13,270.63l-5.9-1.28c-.06-.01-.12.03-.13.09-.01.06.03.12.09.13l5.89,1.28s.02,0,.02,0c.05,0,.1-.04.11-.09.01-.06-.03-.12-.09-.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898a8d",
    strokeWidth: "0px",
    d: "M50.51,252.25h-4.22c-.77,0-1.41.63-1.41,1.41v3.36h7.03v-3.36c0-.77-.63-1.41-1.41-1.41M48.15,256.31h-1.92v-3.35h1.88v.55h-1.2v.79h1.13v.55h-1.13v.9h1.25v.56ZM49.42,256.37c-.35,0-.62-.08-.8-.23-.18-.15-.27-.41-.27-.78v-.1h.68v.09c0,.18.03.31.1.4.07.08.18.13.35.13.12,0,.22-.04.29-.11.07-.07.11-.17.11-.31,0-.1-.02-.19-.05-.26-.04-.07-.11-.13-.23-.18-.4-.16-.65-.27-.74-.32-.1-.05-.18-.12-.24-.19s-.12-.16-.15-.26c-.04-.1-.06-.23-.06-.37,0-.32.09-.56.27-.73.18-.17.44-.25.77-.25s.59.08.77.23c.18.15.27.38.27.69v.08h-.65c0-.33-.12-.5-.37-.5-.26,0-.38.13-.38.39,0,.12.03.22.08.28.05.06.14.12.27.18l.52.23c.23.09.39.21.49.35.1.14.15.32.15.54,0,.69-.39,1.03-1.17,1.03"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaistback);
export default __webpack_public_path__ + "static/media/waistback.1dc669d7d1365fcecab5de0e1ed5fb29.svg";
export { ForwardRef as ReactComponent };